export default "/images/e677d5ba0764a9200959b4fcaee30c89.avif";